import { Box, Typography } from '@mui/material'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import { CustomThemeContext } from 'common/providers/CustomThemeProvider'
import CamposAuxiliares from 'features/datos_trabajador/components/CamposAuxiliares'
import { selectPortal } from 'features/portal/portalSlice'
import i18n from 'lang/idiomas'
import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import useFetchProfessionalData from '../hooks/useFetchProfesionalData'

/**
 * Visor de datos profesionales del trabajador
 *
 * @param {Object} props
 * @param {Object} [props.otrosDatos = null] - Other worker data including auxiliary fields
 */
const Profesionales = ({ otrosDatos = null }) => {
  const { themeController } = useContext(CustomThemeContext)
  const location = useLocation()
  const user = location?.state?.user ?? null
  const { response } = useFetchProfessionalData(user)
  const portal = useSelector(selectPortal)
  const [datosProfesionales, setDatosProfesionales] = useState(response)

  useEffect(() => {
    setDatosProfesionales(response)
  }, [response])

  const locale = portal?.locale

  return (
    <Box>
      <Box sx={{ my: 3, display: 'flex', gap: 2 }}>
        <Typography variant="h3">
          {i18n.t('profesio', { defaultValue: 'Profesionales' })}
        </Typography>
      </Box>
      <Stack>
        <Grid className="outline-paper" container spacing={2}>
          <Grid item size={{ xs: 12 }}>
            <Card sx={{ flexGrow: 1 }}>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                      <ListItem>
                        <ListItemText
                          primary={i18n.t('fechalt', { defaultValue: 'Fecha alta' })}
                          secondary={`${datosProfesionales?.fecha_alta ?? ''}`}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={i18n.t('fechant', { defaultValue: 'Fecha antigüedad' })}
                          secondary={`${datosProfesionales?.fecha_antiguedad ?? ''}`}
                        />
                      </ListItem>
                      {themeController.hide?.WorkerData?.Personal?.Situacion ? (
                        <></>
                      ) : (
                        <ListItem>
                          <ListItemText
                            primary={i18n.t('situacio', { defaultValue: 'Situación' })}
                            secondary={`${datosProfesionales?.situacion ?? ''}`}
                          />
                        </ListItem>
                      )}
                      <ListItem>
                        <ListItemText
                          primary={i18n.t('centro', { defaultValue: 'Centro' })}
                          secondary={`${datosProfesionales?.d_centro_trabajo ?? ''}`}
                        />
                      </ListItem>
                      {themeController.hide?.WorkerData?.Professional?.Service ? (
                        <></>
                      ) : (
                        <ListItem>
                          <ListItemText
                            primary={i18n.t('servicio', { defaultValue: 'Servicio' })}
                            secondary={`${datosProfesionales?.servicio ?? ''}`}
                          />
                        </ListItem>
                      )}
                    </List>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                      {themeController.hide?.WorkerData?.Professional?.Convenio ? (
                        <></>
                      ) : (
                        <ListItem>
                          <ListItemText
                            primary={i18n.t('convenio', { defaultValue: 'Convenio' })}
                            secondary={`${datosProfesionales?.d_convenio ?? ''}`}
                          />
                        </ListItem>
                      )}
                      {themeController.hide?.WorkerData?.Personal?.Categoria ? (
                        <></>
                      ) : (
                        <ListItem>
                          <ListItemText
                            primary={i18n.t('familias.categori', { defaultValue: 'Categoría' })}
                            secondary={`${datosProfesionales?.d_categoria ?? ''}`}
                          />
                        </ListItem>
                      )}
                      {themeController.hide?.WorkerData?.Professional?.Contract ? (
                        <></>
                      ) : (
                        <ListItem>
                          <ListItemText
                            primary={i18n.t('contrato', { defaultValue: 'Contrato' })}
                            secondary={`${datosProfesionales?.d_contrato ?? ''}`}
                          />
                        </ListItem>
                      )}
                      {themeController.hide?.WorkerData?.Professional?.Hours ? (
                        <></>
                      ) : (
                        <ListItem>
                          <ListItemText
                            primary={i18n.t('horas', { defaultValue: 'Horas' })}
                            secondary={`${datosProfesionales?.horas_contrato ? Number(datosProfesionales?.horas_contrato) : ''}`}
                          />
                        </ListItem>
                      )}
                      {themeController.hide?.WorkerData?.Professional?.PortionHours ? (
                        <></>
                      ) : (
                        <ListItem>
                          <ListItemText
                            primary={i18n.t('porcjorn', { defaultValue: '% Jornada' })}
                            secondary={`${datosProfesionales?.porc_horas ? Number(datosProfesionales?.porc_horas).toFixed(2) : ''}`}
                          />
                        </ListItem>
                      )}
                    </List>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                      {themeController.hide?.WorkerData?.Professional?.ShowNetAmmount ? (
                        <ListItem>
                          <ListItemText
                            primary={i18n.t('brutpact', { defaultValue: 'Bruto pactado' })}
                            secondary={`${datosProfesionales?.bruto_pactado ?? ''}`}
                          />
                        </ListItem>
                      ) : (
                        <></>
                      )}
                      <CamposAuxiliares
                        otrosDatos={otrosDatos}
                        seccion="PROF"
                        subseccion="PROF"
                        locale={locale}
                      />
                    </List>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  )
}

export default Profesionales
